let $parent = $('.js-calendar');
let $dateInputs = $parent.find('input');
let $resultContainer = $('.js-calendar-result');

let date1String = app.url.getCurParam('d1');
let date2String = app.url.getCurParam('d2');

if (date1String && date2String) {
    $dateInputs.eq(0).val(date1String);
    $dateInputs.eq(1).val(date2String);
} else {
    $dateInputs.val(app.date.getTodayStringDate());
}

initDatepicker();

if (date1String || date2String) {
    calcDate();
}

$parent.on('changeDate', calcDate);
$dateInputs.on('keyup', calcDate);
$dateInputs.on('change', calcDate);

function initDatepicker() {
    let options = {
        format: "yyyy-mm-dd",
        todayBtn: true,
        language: "ru",
        calendarWeeks: true,
        todayHighlight: true,
        autoclose: true,
        weekStart: 1,
        inputs: $dateInputs
    };

    $parent.datepicker(options);
}

function calcDate() {
    let date1 = new Date($dateInputs.eq(0).val() || app.date.getTodayStringDate());
    let date2 = new Date($dateInputs.eq(1).val() || app.date.getTodayStringDate());

    app.url.setCurParam('d1', app.date.getStringDate(date1));
    app.url.setCurParam('d2', app.date.getStringDate(date2));

    if (date2 < date1) {
        [date1, date2] = [date2, date1];
    }

    let dateDiffSeconds = (date2 - date1) / 1000;

    let dateDescriptions = [
        [1, ['getSeconds', ''], 'секунда', 'секунды', 'секунд'],
        [60, ['getMinutes', 'setMinutes', 60], 'минута', 'минуты', 'минут'],
        [60 * 60, ['getHours', 'setHours', 60], 'час', 'часа', 'часов'],
        [60 * 60 * 24, ['getDate', 'setDate', 24], 'день', 'дня', 'дней'],
        [60 * 60 * 24 * 7, false, 'неделя', 'недели', 'недель'],
        [(date1, date2) => app.date.getMonthsBetweenDates(date1, date2), ['getMonth', 'setMonth', app.date.getMonthDaysCount(date2.getMonth(), date2.getYear())], 'месяц', 'месяца', 'месяцев'],
        [(date1, date2) => (app.date.getMonthsBetweenDates(date1, date2) / 12), ['getFullYear', 'setFullYear', 12], 'год', 'года', 'лет'],
    ];

    for (let i = 0; i < dateDescriptions.length; i++) {
        dateDescriptions[i][0] = typeof dateDescriptions[i][0] === 'function'
            ? dateDescriptions[i][0](date1, date2)
            : dateDiffSeconds / dateDescriptions[i][0];
    }

    $resultContainer.html('<div>' + calcByLang('ru') + '</div><div>' + calcByLang('en') + '</div>');

    function calcByLang(lang) {
        let msg = `${__('Между', lang)} ${$dateInputs[0].value} ${__('и', lang)} ${$dateInputs[1].value}`;
        if (dateDiffSeconds) {
            msg += ':<br>' + getEachDateCompareArray(dateDescriptions, date1, date2, lang).join(' ' + __('или', lang) + '<br>');

            let fullDateCompareArray = getFullDateCompareArray(dateDescriptions, date1, date2, lang);
            if (fullDateCompareArray.length > 1) {
                msg += ' ' + __('или', lang) + ' <br>' + fullDateCompareArray.join(' ');
            }
        } else {
            msg += ' ' + __('ничего нет', lang);
        }
        return msg;
    }
}

function getEachDateCompareArray(dateDescriptions, date1, date2, lang) {
    let result = [];
    for (let dateDescription of dateDescriptions) {
        if (dateDescription[0] < 0.005) break;
        let tilda = dateDescription[0] != dateDescription[0].toFixed(2) ? '~ ' : '';
        result.push(`<b>${tilda}${app.number.format(dateDescription[0])}</b> ${app.i18n.getPlural(dateDescription[0], dateDescription[2], dateDescription[3], dateDescription[4], lang)}`);
    }
    return result;
}

function getFullDateCompareArray(dateDescriptions, date1, date2, lang) {
    let result = [];
    let date = new Date(date2.getTime());
    for (let i = 0; i < dateDescriptions.length; i++) {
        let dateDescription = dateDescriptions[i];
        if (!dateDescription[1]) continue;

        let curVal = date[dateDescription[1][0]]() - date1[dateDescription[1][0]]();
        if (curVal < 0) {
            for (let j = i + 1; j < dateDescriptions.length; j++) {
                if (!dateDescriptions[j][1]) continue;
                curVal += dateDescriptions[j][1][2];
                date[dateDescriptions[j][1][1]](date[dateDescriptions[j][1][0]]() - 1);
                break;
            }
        }
        if (curVal < 1) continue;

        result.push(`<b>${app.number.format(curVal)}</b> ${app.i18n.getPlural(curVal, dateDescription[2], dateDescription[3], dateDescription[4], lang)}`);
    }
    return result.reverse();
}